var _g, _clipPath, _use, _clipPath2, _use2, _clipPath3, _use3, _clipPath4, _use4, _clipPath5, _use5, _clipPath6, _use6, _clipPath7, _use7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    height: 27,
    id: "screenshot-2219adfb-ae7d-809d-8007-f1aaf0ca60a8",
    viewBox: "0 0 28 27",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60a8",
    rx: 0,
    ry: 0,
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60a9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60a9"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 27,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60aa",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.999868392944336,1.9288116693496704L27.999868392944336,11.571878433227539L27.999868392944336,26.35752296447754L-0.00013147410936653614,26.35752296447754L-0.00013147410936653614,11.571878433227539L13.999868392944336,1.9288116693496704M27.999868392944336,11.571878433227539L-0.00013147410936653614,11.571878433227539",
    style: {
      fill: "rgb(217, 217, 217)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-55dee2f1-041b-80c9-8007-f1ab1e9dc6ba-2219adfb-ae7d-809d-8007-f1aaf0ca60aa",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-3-2219adfb-ae7d-809d-8007-f1aaf0ca60aa-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-2219adfb-ae7d-809d-8007-f1aaf0ca60aa-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.999868392944336,1.9288116693496704L27.999868392944336,11.571878433227539L27.999868392944336,26.35752296447754L-0.00013147410936653614,26.35752296447754L-0.00013147410936653614,11.571878433227539L13.999868392944336,1.9288116693496704M27.999868392944336,11.571878433227539L-0.00013147410936653614,11.571878433227539",
    id: "stroke-shape-render-3-2219adfb-ae7d-809d-8007-f1aaf0ca60aa-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(28, 72, 182)",
      strokeOpacity: 1
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-2219adfb-ae7d-809d-8007-f1aaf0ca60aa-0",
    clipPath: "url('#inner-stroke-render-3-2219adfb-ae7d-809d-8007-f1aaf0ca60aa-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60ab",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.363637924194336,3.85703444480896L24.181997299194336,3.85703444480896L24.181997299194336,26.67832374572754L6.363637924194336,26.67832374572754L6.363637924194336,3.85703444480896Z",
    fillRule: "nonzero",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "strokes-55dee2f1-041b-80c9-8007-f1ab1e9ec2c5-2219adfb-ae7d-809d-8007-f1aaf0ca60ab",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-4-2219adfb-ae7d-809d-8007-f1aaf0ca60ab-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-4-2219adfb-ae7d-809d-8007-f1aaf0ca60ab-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M6.363637924194336,3.85703444480896L24.181997299194336,3.85703444480896L24.181997299194336,26.67832374572754L6.363637924194336,26.67832374572754L6.363637924194336,3.85703444480896Z",
    id: "stroke-shape-render-4-2219adfb-ae7d-809d-8007-f1aaf0ca60ab-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1
    }
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-4-2219adfb-ae7d-809d-8007-f1aaf0ca60ab-0",
    clipPath: "url('#inner-stroke-render-4-2219adfb-ae7d-809d-8007-f1aaf0ca60ab-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60ac",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.090688705444336,5.143167018890381L22.909048080444336,5.143167018890381L22.909048080444336,26.67881202697754L5.090688705444336,26.67881202697754L5.090688705444336,5.143167018890381Z",
    fillRule: "nonzero",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "strokes-55dee2f1-041b-80c9-8007-f1ab1e9f65b1-2219adfb-ae7d-809d-8007-f1aaf0ca60ac",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-5-2219adfb-ae7d-809d-8007-f1aaf0ca60ac-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-5-2219adfb-ae7d-809d-8007-f1aaf0ca60ac-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.090688705444336,5.143167018890381L22.909048080444336,5.143167018890381L22.909048080444336,26.67881202697754L5.090688705444336,26.67881202697754L5.090688705444336,5.143167018890381Z",
    id: "stroke-shape-render-5-2219adfb-ae7d-809d-8007-f1aaf0ca60ac-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1
    }
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-5-2219adfb-ae7d-809d-8007-f1aaf0ca60ac-0",
    clipPath: "url('#inner-stroke-render-5-2219adfb-ae7d-809d-8007-f1aaf0ca60ac-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60ad",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.818228006362915,6.428811550140381L17.181997299194336,6.428811550140381L21.636587142944336,6.428811550140381L21.636587142944336,26.67881202697754L3.818228006362915,26.67881202697754L3.818228006362915,6.428811550140381Z",
    fillRule: "nonzero",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "strokes-55dee2f1-041b-80c9-8007-f1ab1e9fc15c-2219adfb-ae7d-809d-8007-f1aaf0ca60ad",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-6-2219adfb-ae7d-809d-8007-f1aaf0ca60ad-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-6-2219adfb-ae7d-809d-8007-f1aaf0ca60ad-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3.818228006362915,6.428811550140381L17.181997299194336,6.428811550140381L21.636587142944336,6.428811550140381L21.636587142944336,26.67881202697754L3.818228006362915,26.67881202697754L3.818228006362915,6.428811550140381Z",
    id: "stroke-shape-render-6-2219adfb-ae7d-809d-8007-f1aaf0ca60ad-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1
    }
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-6-2219adfb-ae7d-809d-8007-f1aaf0ca60ad-0",
    clipPath: "url('#inner-stroke-render-6-2219adfb-ae7d-809d-8007-f1aaf0ca60ad-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60ae",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60ae"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 9.54541015625,
    y: 9,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 10.181818008422852,
    height: 0.6428571343421936,
    style: {
      fill: "rgb(76, 76, 76)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60af",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60af"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 9.54541015625,
    y: 10.9287109375,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 10.181818008422852,
    height: 0.6428571343421936,
    style: {
      fill: "rgb(76, 76, 76)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60b0",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60b0"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 5.72705078125,
    y: 12.85693359375,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 14,
    height: 0.6428571343421936,
    style: {
      fill: "rgb(76, 76, 76)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60b1",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60b1"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 5.72705078125,
    y: 9,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 2.545454502105713,
    height: 2.5714285373687744,
    style: {
      fill: "rgb(224, 229, 233)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-55dee2f1-041b-80c9-8007-f1ab1ea15b71-2219adfb-ae7d-809d-8007-f1aaf0ca60b1",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-10-2219adfb-ae7d-809d-8007-f1aaf0ca60b1-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-10-2219adfb-ae7d-809d-8007-f1aaf0ca60b1-0"
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 5.72705078125,
    y: 9,
    width: 2.545454502105713,
    height: 2.5714285373687744,
    id: "stroke-shape-render-10-2219adfb-ae7d-809d-8007-f1aaf0ca60b1-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1
    }
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-10-2219adfb-ae7d-809d-8007-f1aaf0ca60b1-0",
    clipPath: "url('#inner-stroke-render-10-2219adfb-ae7d-809d-8007-f1aaf0ca60b1-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60b2",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.999868392944336,21.85752296447754L27.999868392944336,12.214456558227539L27.999868392944336,27.00010108947754L-0.00013147410936653614,27.00010108947754L-0.00013147410936653614,12.214456558227539L13.999868392944336,21.85752296447754",
    style: {
      fill: "rgb(217, 217, 217)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-55dee2f1-041b-80c9-8007-f1ab1ea21581-2219adfb-ae7d-809d-8007-f1aaf0ca60b2",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-11-2219adfb-ae7d-809d-8007-f1aaf0ca60b2-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-11-2219adfb-ae7d-809d-8007-f1aaf0ca60b2-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.999868392944336,21.85752296447754L27.999868392944336,12.214456558227539L27.999868392944336,27.00010108947754L-0.00013147410936653614,27.00010108947754L-0.00013147410936653614,12.214456558227539L13.999868392944336,21.85752296447754",
    id: "stroke-shape-render-11-2219adfb-ae7d-809d-8007-f1aaf0ca60b2-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(28, 72, 182)",
      strokeOpacity: 1
    }
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-11-2219adfb-ae7d-809d-8007-f1aaf0ca60b2-0",
    clipPath: "url('#inner-stroke-render-11-2219adfb-ae7d-809d-8007-f1aaf0ca60b2-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2219adfb-ae7d-809d-8007-f1aaf0ca60b3",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2219adfb-ae7d-809d-8007-f1aaf0ca60b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.999868392944336,17.35703468322754L27.999868392944336,27.00010108947754L-0.00013147410936653614,27.00010108947754L13.999868392944336,17.35703468322754Z",
    fillRule: "nonzero",
    style: {
      fill: "rgb(55, 101, 219)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "strokes-55dee2f1-041b-80c9-8007-f1ab1ea2e1ef-2219adfb-ae7d-809d-8007-f1aaf0ca60b3",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-12-2219adfb-ae7d-809d-8007-f1aaf0ca60b3-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-12-2219adfb-ae7d-809d-8007-f1aaf0ca60b3-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.999868392944336,17.35703468322754L27.999868392944336,27.00010108947754L-0.00013147410936653614,27.00010108947754L13.999868392944336,17.35703468322754Z",
    id: "stroke-shape-render-12-2219adfb-ae7d-809d-8007-f1aaf0ca60b3-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(28, 72, 182)",
      strokeOpacity: 1
    }
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-12-2219adfb-ae7d-809d-8007-f1aaf0ca60b3-0",
    clipPath: "url('#inner-stroke-render-12-2219adfb-ae7d-809d-8007-f1aaf0ca60b3-0')"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e25c6d1eae23fd19a60ffd654cbc8fa.svg";
export { ForwardRef as ReactComponent };